import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_TEMPLATES } from '@/lib/constants/api'
import getWorkflowTemplateTaskModel from './models/workflowTemplateTask'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowTemplateTask = {
  namespaced: true,
  state: {
    ...getWorkflowTemplateTaskModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearWorkflowTemplateTask: (state) => {
      const model = getWorkflowTemplateTaskModel()
      Object.keys(model).forEach(key => { state[key] = model[key] })
    },
    setWorkflowTemplateTask: (state, task) => {
      state.id = task.id
      state.workflowTemplateId = task.workflowTemplateId
      state.title = task.title
      state.description = task.description
      state.defaultAssigneeRoleId = task.defaultAssigneeRoleId
      state.dueDateAnchorId = task.dueDateAnchorId
      state.dueDateAnchorName = task.dueDateAnchorName
      state.dueDateOffsetDays = task.dueDateOffsetDays
      state.blockerTaskId = task.blockerTaskId
      state.blockerTaskTitle = task.blockerTaskTitle
      state.sortOrder = task.sortOrder
      state.isActive = task.isActive
      state.createdBy = task.createdBy
      state.updatedBy = task.updatedBy
      state.createdAt = task.createdAt
      state.updatedAt = task.updatedAt
    }
  },
  actions: {
    save (context, taskData) {
      const { workflowTemplateId, title, description, defaultAssigneeRoleId, dueDateAnchorId, dueDateOffsetDays, blockerTaskId, sortOrder, isActive, taskTypeId, workflowEmailTemplateId, documentTemplateId, attachments } = taskData
      const path = `${PATH_WORKFLOW_TEMPLATES}/${workflowTemplateId}/tasks`
      return api.doPost({ path, data: { workflowTemplateId, title, description, defaultAssigneeRoleId, dueDateAnchorId, dueDateOffsetDays, blockerTaskId, sortOrder, isActive, taskTypeId, workflowEmailTemplateId, documentTemplateId, attachments } })
    },
    update (context, taskData) {
      const { id, workflowTemplateId, title, description, defaultAssigneeRoleId, dueDateAnchorId, dueDateOffsetDays, blockerTaskId, sortOrder, isActive, taskTypeId, workflowEmailTemplateId, documentTemplateId, attachments } = taskData
      const path = `${PATH_WORKFLOW_TEMPLATES}/${workflowTemplateId}/tasks`
      return api.doPut({ path, data: { id, workflowTemplateId, title, description, defaultAssigneeRoleId, dueDateAnchorId, dueDateOffsetDays, blockerTaskId, sortOrder, isActive, taskTypeId, workflowEmailTemplateId, documentTemplateId, attachments } })
    },
    saveWorkflowTemplateTask: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving task, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        if (!response.data) {
          if (response.errorMessage) {
            throw new Error(response.errorMessage)
          }
          throw new Error('Unable to save task. Check required fields.')
        }

        commit('clearWorkflowTemplateTask')
        commit('updateStatus', { status: COMPLETE })
        notifySuccess(dispatch, 'Task saved')

        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, error || 'Unable to save task. Try again later')
        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearWorkflowTemplateTask: ({ commit }) => {
      commit('clearWorkflowTemplateTask')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default workflowTemplateTask
